import PropTypes from 'prop-types'
import React from 'react'
import glamorous from 'glamorous'
import { BodyText, CaptionText } from '@paypalcorp/pp-react'

import { isDw2Repaint } from 'experiments/dw2Repaint'

const ConversionRateWrapper = glamorous.div({
  fontFamily: 'PayPalSansBig-Regular,"Helvetica Neue",Arial,sans-serif',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: 0,
  color: '#2C2E2F',
})

const DisclaimerRateWrapper = glamorous.div({
  marginTop: '0.3em',
})

function renderDisclaimer(currencyCodeDisclaimer) {
  return (
    <DisclaimerRateWrapper>
      <BodyText as="p" strong>
        {currencyCodeDisclaimer}
      </BodyText>
    </DisclaimerRateWrapper>
  )
}

/**
 * Displays the conversion rate in an xbCalc-row
 */
function ConversionRate(props) {
  return (
    <>
      {isDw2Repaint() ? (
        <>
          {props.currencyCodeDisclaimer &&
            renderDisclaimer(props.currencyCodeDisclaimer)}
          <BodyText data-nemo="xb-conversion-rate">
            {props.exchangeRateText}
          </BodyText>
          <DisclaimerRateWrapper>
            <CaptionText data-nemo="xbCalc-instructions">
              {props.disclaimerText}
            </CaptionText>
          </DisclaimerRateWrapper>
        </>
      ) : (
        <ConversionRateWrapper className="txtCenter" style={props.style}>
          <span className="xbCalc-exchangeRate">
            <span className="xbCalc-disclaimer txtBold">
              {props.currencyCodeDisclaimer}
            </span>
            <span
              className="xbCalc-exchangeRate_label"
              data-nemo="xb-conversion-rate"
            >
              {props.exchangeRateText}
            </span>
          </span>
          <span className="xbCalc-disclaimer xbCalc-instructions">
            {props.disclaimerText}
          </span>
        </ConversionRateWrapper>
      )}
    </>
  )
}

ConversionRate.propTypes = {
  style: PropTypes.object,
  disclaimerText: PropTypes.string,
  exchangeRateText: PropTypes.string.isRequired,
  currencyCodeDisclaimer: PropTypes.string,
}

export default ConversionRate
